import styled from "vue-styled-components";


export const CTitleProducts = styled.div`
    text-align: ${props => props.theme.text_align_titles ?? 'center'};
.title-h2 {

    color: ${props => props.theme.home_page?.titles?.color ?? '#000'};
    font-size: ${props => props.theme.home_page?.titles?.font_size ?? '2rem'};
    margin-top:15px;
    margin-bottom:15px;
    left: 0;
    font-weight: ${props => props.theme.home_page?.titles?.font_weight ?? '400'};
    font-family: ${props => props.theme.home_page?.titles?.font_family ?? props.theme.font_family ?? 'Open Sans'}, sans-serif;
    text-transform: ${props => props.theme.home_page?.titles?.text_transform ?? 'capitalize'};

        font-weight: ${props => props.theme.home_page?.titles?.strong_font_weight ?? '700'} ;
        padding-bottom: ${props => props.theme.home_page?.titles?.padding_bottom ?? '5px'} ;
        border-bottom: ${props => props.theme.home_page?.titles?.border_width ?? '3px'} solid ${props => props.theme.home_page?.titles?.border_color ?? props.theme.primary_color} ;
}
`;
